import React from 'react'
import Login from '../components/Login'

const Log = () => {
  return (
    <Login/>
  )
}

export default Log